/**
 * @file ログイン画面でreturn urlをセット
 */
'use strict';

/**
 * @classname LoginForm
 * @classdesc ログイン画面でreturn urlをセット
 */
export default class LoginForm {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('LoginForm.constructor');
		this._$e = $e;
		const queryString = window.location.search;
		const returnUrlValue = this.getParameterByName('return_url', queryString);

		if (returnUrlValue !== null) {
			console.log('return_url の値は: ' + returnUrlValue);
			this._$input = $('#return_url')
			this._$input.val(returnUrlValue)
		}
	};

	getParameterByName(name, url) {
		name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(url);
		return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}
}
